import { render, staticRenderFns } from "./HeatmapOverlayLayer.vue?vue&type=template&id=4d6057b9"
import script from "./HeatmapOverlayLayer.vue?vue&type=script&lang=js"
export * from "./HeatmapOverlayLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports